export function getMerchShippingFee(product, fulfillmentMethod) {
  if (fulfillmentMethod !== 'shipping') return 0;
  return Math.max(0, parseFloat(product?.costoSpedizione) || 0);
}

export function calculateMerchCheckoutTotal({
  product,
  discountPercentage = 0,
  fulfillmentMethod = 'pickup',
  quantity = 1,
}) {
  const unitPrice = parseFloat(product?.prezzo) || 0;
  const qty = Math.max(1, Number(quantity) || 1);
  const productSubtotal = unitPrice * qty;
  const discountPct = Math.max(0, parseFloat(discountPercentage) || 0);
  const discountAmount =
    discountPct > 0 ? (productSubtotal * discountPct) / 100 : 0;
  const productTotal = productSubtotal - discountAmount;
  const shippingFee = getMerchShippingFee(product, fulfillmentMethod);
  const total = productTotal + shippingFee;

  return {
    productSubtotal,
    discountAmount,
    productTotal,
    shippingFee,
    total,
  };
}
